import { onboardingRegistrationAccessHelper } from 'legacy/lut/classes/helpers/OnboardingRegistrationAccessHelper'
import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'
import React, { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { getUrlParam, getUrlWithParams } from 'core-components/helpers/url'
import { Button } from 'core-components/library/button'
import { LoaderOverlay } from 'core-components/library/loader'
import {
  Controller,
  isValidEmail,
  ValidateInput,
  ValidationStatus,
} from 'core-components/library/validation'
import { userApi } from 'core/classes/services/api/UserApi'
import { requestService } from 'onboarding/services/requestService'

import styles from './DistributorsOnBehalfLoginPage.module.scss'

export const DistributorsOnBehalfGuestLogin = () => {
  const [email, setEmail] = useState('')
  const [canSave, setCanSave] = useState(true)
  const [warningMessage, setWarningMessage] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const handleAccess = useCallback(async () => {
    const requestId = Number(getUrlParam('rid'))
    let redirectRequestId

    setIsLoading(true)

    if (requestId) {
      const access =
        await onboardingRegistrationAccessHelper.checkEmailAccessToUpdateDistributorsOnBehalf(
          email,
          requestId
        )
      if (!access) {
        // TODO: add translations
        setWarningMessage("You don't have access to this request")
        setIsLoading(false)
        return
      }
    } else {
      redirectRequestId = await requestService.searchAvailableRequestByEmail(
        RequestTypes.BPRegistration,
        email
      )
      if (!redirectRequestId) {
        // TODO: add translations
        setWarningMessage('The registration is not found for your email')
        setIsLoading(false)
        return
      }
    }

    const isSignSuccess = await userApi.signInGuest(email)
    if (isSignSuccess) {
      if (redirectRequestId) {
        navigate(getUrlWithParams({ rid: redirectRequestId }))
      }
      window.location.reload()
    }

    setIsLoading(false)
  }, [email, navigate])

  if (warningMessage && !isLoading) {
    return <p className={styles.warning}>{warningMessage}</p>
  }

  return (
    <div>
      <LoaderOverlay show={isLoading} />
      {/* TODO: add translations */}
      <div className={styles.description}>To update distributors on behalf enter your email</div>
      <Controller
        onValidationStatusChange={({ status }) => {
          if (status !== ValidationStatus.WIP) {
            setCanSave(status === ValidationStatus.Valid)
          }
        }}
      >
        <ValidateInput
          // TODO: add translations
          label={'Enter email'}
          value={email}
          onChange={(value) => setEmail(value.trim())}
          checkFn={isValidEmail}
          margin={'sm'}
        />
      </Controller>
      <Button
        className={styles.buttonSignIn}
        disabled={!email || !canSave}
        variant={'outlined'}
        onClick={handleAccess}
      >
        {/* TODO: add translations */}
        Submit
      </Button>
    </div>
  )
}
